import React, { useEffect } from 'react';

/**
 * QA 스크롤 관리를 담당하는 커스텀 훅
 * @param {Array} qaHistory - QA 히스토리 배열
 * @returns {object} - 스크롤 관련 함수들과 refs
 */
export const useQAScrolling = (qaHistory) => {
  // 답변 박스별 ref 배열 준비
  const initializeAnswerRefs = () => {
    if (!window.answerRefs) window.answerRefs = [];
    window.answerRefs.length = qaHistory.length;
    for (let i = 0; i < qaHistory.length; i++) {
      if (!window.answerRefs[i]) window.answerRefs[i] = React.createRef();
    }
  };

  // 답변이 생성될 때 해당 박스가 'TubeDigest AI와의 대화' 바로 아래에 오도록 스크롤
  useEffect(() => {
    if (!qaHistory || qaHistory.length === 0) return;
    
    const lastIdx = qaHistory.length - 1;
    if (qaHistory[lastIdx].answer) {
      const ref = window.answerRefs && window.answerRefs[lastIdx];
      const scrollContainer = document.querySelector('.qa-scroll-container');
      const titleElem = document.getElementById('qa-title');
      
      if (ref && ref.current && scrollContainer && titleElem) {
        const offset = ref.current.offsetTop - (titleElem.offsetTop + titleElem.offsetHeight) - 16; // 16px은 여유 padding
        scrollContainer.scrollTop = offset;
      }
    }
  }, [qaHistory]);

  return {
    initializeAnswerRefs,
    answerRefs: window.answerRefs
  };
}; 